import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import MaintenanceNotice from "./views/MaintenanceNotice";
import NoMatch from "./views/NoMatch";
import Order from "./views/Order";
import Search from "./views/Search";
import ForgotOrderNo from "./views/Search/containers/ForgotOrderNo";

const maintenanceModeEnabled = false;

export default class App extends React.Component {
    render() {
        if (maintenanceModeEnabled) {
            return (
                <Switch>
                    <Route exact path="/maintenance" component={MaintenanceNotice} />

                    <Route render={({ location }) => <Redirect to={{ pathname: "/maintenance", search: location.search }} />} />
                </Switch>
            );
        }

        return (
            <Switch>
                <Route exact path="/maintenance" component={MaintenanceNotice} />

                <Route exact path="/404" component={NoMatch} />

                <Route exact path="/embedded/search" component={Search} />

                <Route exact path="/embedded/search/forgot-order-no" component={ForgotOrderNo} />

                <Route exact path="/embedded/orders/:order_id" component={Order} />

                <Redirect to="/404" />
            </Switch>
        );
    }
}
